module.exports = __webpack_public_path__ + "cfaedb2156591be8b9e5d05a5c6a8a76.ttf";